/**
 * HM-105 — Reception Room Service API client.
 */
import { api } from './client.js';

export type KitchenOrderStatus = 'pending' | 'preparing' | 'delivered' | 'cancelled';

export type KitchenOrder = {
  id: string;
  status: KitchenOrderStatus;
  roomId: string;
  bookingId: string;
  total: string;
  note: string | null;
  placedAt: string;
};

export async function fetchKitchenOrders(): Promise<{ orders: KitchenOrder[] }> {
  return api('/room-service/orders');
}

export async function transitionOrder(
  orderId: string,
  status: 'preparing' | 'delivered' | 'cancelled',
): Promise<{ orderId: string; status: KitchenOrderStatus; deliveredAt: string | null }> {
  return api(`/room-service/orders/${orderId}`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  });
}
